/** Frequently asked questions. */

export const FAQ = {
  eyebrow: 'FAQs',
  title: 'Frequently asked questions',
  items: [
    {
      q: 'Who is MeetNPlan for?',
      a: 'Companies that share meeting rooms and receive visitors. Each role gets its own panel: User, HR, Reception and Admin.',
    },
    {
      q: 'Does it work in Arabic?',
      a: 'Yes. The whole app works right-to-left in Arabic, and anyone can switch to English.',
    },
    {
      q: 'Can it sync with Google Calendar?',
      a: 'Yes. Meetings booked in MeetNPlan appear in Google Calendar, and invites go out by email.',
    },
    {
      q: 'How do visitors sign in?',
      a: 'Reception signs in walk-ins in a few steps with a signature. VIP guests are signed in with one press.',
    },
    {
      q: 'How do I get started?',
      a: 'Book a demo and we will set up your rooms and team with you.',
    },
  ],
}
